export function debounce<T>(func: (value: T) => void, timeout = 300) {
  let timer: NodeJS.Timeout;
  return (value: T) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(value);
    }, timeout);
  };
}

export function debounceFunction<F extends (...args: any[]) => any>(func: F, timeout = 300, timerObject: {timer?: NodeJS.Timeout | undefined} = {}): (...args: Parameters<F>) => void {
  clearTimeout(timerObject.timer);
  return (...args: Parameters<F>) => {
    timerObject.timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}
